import { Action } from '@ngrx/store';
import {
  ActivityReport, ActivityReportRequest,
} from '../shared/models';
import { BlobWithFilename } from '../../../shared/models';

const working = '[activity]';
export const activityTypes = {

  /* Activity */
  LOAD_ACTIVITY: working + ' load-activity',
  LOAD_ACTIVITY_SUCCESS: working + ' load-activity-success',
  LOAD_ACTIVITY_FAILS: working + ' load-activity-fails',
  CLEAR_ACTIVITY: working + ' clear-activity',

  /* Activity Export */
  LOAD_ACTIVITY_AS_EXCEL: working + ' load-activity-as-excel',
  LOAD_ACTIVITY_AS_EXCEL_SUCCESS: working + ' load-activity-as-excel-success',
  LOAD_ACTIVITY_AS_EXCEL_FAILS: working + ' load-activity-as-excel-fails',
};

/* Activity */
export class LoadActivityAction implements Action {
  readonly type = activityTypes.LOAD_ACTIVITY;
  constructor(public payload: ActivityReportRequest) {}
}

export class LoadActivitySuccessAction implements Action {
  readonly type = activityTypes.LOAD_ACTIVITY_SUCCESS;
  constructor(public payload: ActivityReport) {}
}

export class LoadActivityFailsAction implements Action {
  readonly type = activityTypes.LOAD_ACTIVITY_FAILS;
  constructor(public payload: any) { }
}

export class ClearActivityAction implements Action {
  readonly type = activityTypes.CLEAR_ACTIVITY;
  constructor(public payload: any = null) { }
}

export class LoadActivityAsExcelAction implements Action {
  readonly type = activityTypes.LOAD_ACTIVITY_AS_EXCEL;
  constructor(public payload: ActivityReportRequest) {}
}

export class LoadActivityAsExcelSuccessAction implements Action {
  readonly type = activityTypes.LOAD_ACTIVITY_AS_EXCEL_SUCCESS;
  constructor(public payload: BlobWithFilename) {}
}

export class LoadActivityAsExcelFailsAction implements Action {
  readonly type = activityTypes.LOAD_ACTIVITY_AS_EXCEL_FAILS;
  constructor(public payload: any) { }
}

export type Actions =
    | LoadActivityAction
    | LoadActivitySuccessAction
    | LoadActivityFailsAction
    | ClearActivityAction
    | LoadActivityAsExcelAction
    | LoadActivityAsExcelSuccessAction
    | LoadActivityAsExcelFailsAction
    ;
